import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@app/shared/services/api-service-base';
import { NgxHttpClient } from '@app/shared/ngx-http-client';
import { TranslateService } from '@ngx-translate/core';
import {
  BookParameters,
  Book,
  InputCreationFeedback,
  InputIdentifier,
} from '@app/inputs/inputs-api.model';

@Injectable({
  providedIn: 'root',
})
export class BookService extends ApiServiceBase {
  private i18n = this.translate.instant([
    'Core_GeneralErrorMessage',
    'InputsSvc_GeneralError',
    'InputsSvc_AddItemError',
    'InputsSvc_EditContentDuplicateError',
    'InputsSvc_GetBookError',
  ]);

  constructor(
    private translate: TranslateService,
    http: NgxHttpClient
  ) {
    super(http, translate.instant('InputsSvc_GeneralError'));
  }

  /**
   * Add a book the the pathway/plan.
   * @param params
   * @returns
   */
  public addBook(params: BookParameters) {
    return this.post<InputCreationFeedback>(
      '/inputs/addbook',
      params,
      this.i18n.InputsSvc_AddItemError
    );
  }

  /**
   * Add a book to the user's profile collection.
   * @param params
   * @returns
   */
  public addUserBook(params: BookParameters) {
    return this.post<InputCreationFeedback>(
      '/userinputs/adduserbook',
      params,
      this.i18n.InputsSvc_AddItemError
    );
  }

  public updateBook(identifier: InputIdentifier) {
    return this.put(
      '/inputs/updatebook',
      identifier,
      this.i18n.InputsSvc_AddItemError
    );
  }

  public getBook(inputId: number, isCms = false) {
    return this.get<Book>(
      '/inputs/getbook',
      { inputId, isCms },
      this.i18n.InputsSvc_GetBookError
    );
  }
}
